<template>
  <div class="edit-user-machine">
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      custom-class="mcVerify"
      :title="biaoshi == 1 ? $t('machineConfig.plConfig') : $t('machineUser.mConfig')"
      :visible.sync="dialogConfigMachine"
      width="1140px"
      top="6vh"
      @open="openDialog"
      @closed="closeDialog"
      :close-on-click-modal="false"
    >
      <div v-loading="loadingForm" :element-loading-text="$t('common.request')">
        <el-row style="margin-bottom: 20px; color: red" v-if="biaoshi == 1">
          {{ $t("machineConfig.pTips") }}
        </el-row>
        <el-form :label-position="labelPosition" :rules="rules" ref="userEquipment" label-width="80px" :model="config">
          <!-- 页面属性 -->
          <div
            style="
              height: 24px;
              line-height: 24px;
              display: flow-root;
              font-size: 15px;
              font-weight: 500;
              color: #000000;
              padding-left: 10px;
              border-left: 5px solid #409eff;
              margin: 0 0 5px 0;
              display: flex;
              align-items: center;
            "
          >
            {{ $t("machineConfig.ymshuxing") }}
          </div>
          <el-row :gutter="20" style="margin-bottom: 0px">
            <el-col :span="6">
              <el-form-item :label="$t('user.ConfigUserMachine.advertPlayModel')">
                <el-select
                  v-model="config.advert.playMode"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option
                    v-for="item in advertPlayMode"
                    :key="item.id"
                    :label="item.label"
                    :value="+item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('machineConfig.isPAd')" prop="isPAd">
                <el-select
                  :disabled="$tools.IsGrayModule('usermahcine:gray:ispad')"
                  v-model="config.info.isPAd"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item prop="isTAd">
                <span slot="label" style="display: flex; flex-wrap: wrap">
                  <span>{{ $t("machineConfig.isTAd") }}</span>
                </span>
                <el-select
                  :disabled="$tools.IsGrayModule('usermahcine:gray:istad')"
                  v-model="config.info.isTAd"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
                <span style="color: red">{{ $t("machineConfig.jzyfp") }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="config.info.isTAd == 1">
              <el-form-item>
                <span slot="label" style="display: flex; flex-wrap: wrap">
                  <span>{{ $t("user.ConfigUserMachine.966810-0") }}</span>
                </span>
                <el-select
                  v-model="config.advert.isCountdown"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="config.info.isTAd == 1">
              <el-form-item :label="$t('user.ConfigUserMachine.966810-1')">
                <el-input v-model="config.advert.countdown" :placeholder="$t('user.ConfigUserMachine.966810-2')">
                  <template slot="append">s</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" v-hasPerm="['usermahcine:hide:isptag']">
              <el-form-item :label="$t('machineConfig.isPTag')">
                <el-select
                  v-model="config.info.isPTag"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- {{ $t('user.ConfigUserMachine.025933-0') }} -->
            <el-col :span="6">
              <el-form-item :label="$t('user.ConfigUserMachine.025933-0')">
                <el-input
                  v-model="config.info.moneySign"
                  :placeholder="$t('user.ConfigUserMachine.025933-1')"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- {{ $t('user.ConfigUserMachine.444674-0') }}-->
            <el-col :span="6" v-hasPerm="['usermahcine:hide:isgoodsmode']">
              <el-form-item :label="$t('user.ConfigUserMachine.444674-0')">
                <el-select
                  v-model="config.info.isGoodsMode"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 故障处理 -->
          <div
            style="
              height: 24px;
              line-height: 24px;
              display: flow-root;
              font-size: 15px;
              font-weight: 500;
              color: #000000;
              padding-left: 10px;
              border-left: 5px solid #409eff;
              margin: 30px 0 5px 0;
              display: flex;
              align-items: center;
            "
          >
            {{ $t("machineConfig.gzchuli") }}
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('machineConfig.gbhuodao')" prop="isFaultClose">
                <el-select
                  v-model="config.info.isFaultClose"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-hasPerm="['usermahcine:hide:islock']">
              <el-form-item :label="$t('editUserMachine.isLock')" prop="isFaultLock">
                <el-select
                  v-model="config.info.isFaultLock"
                  filterable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 管理员 -->
          <div
            style="
              height: 24px;
              line-height: 24px;
              display: flow-root;
              font-size: 15px;
              font-weight: 500;
              color: #000000;
              padding-left: 10px;
              border-left: 5px solid #409eff;
              margin: 30px 0 5px 0;
              display: flex;
              align-items: center;
            "
          >
            {{ $t("machineConfig.glyuan") }}
          </div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('machineConfig.merConfig')" prop="isOpen">
                <el-select
                  v-model="config.manager.isOpen"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="config.manager.isOpen == 1">
              <el-form-item :label="$t('addUser.mpassword')" prop="passWord">
                <el-input
                  v-model="config.manager.passWord"
                  :placeholder="$t('addUser.pePassword')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="config.manager.isOpen == 1">
              <el-form-item :label="$t('editUserMachine.isDebug')" prop="isDebug">
                <el-select
                  v-model="config.manager.isDebug"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('editUserMachine.isCoupon')" prop="isCoupon">
                <el-select
                  v-model="config.info.isCoupon"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 设备模式 -->
          <div
            v-hasPerm="['usermahcine:hide:model']"
            style="
              height: 24px;
              line-height: 24px;
              display: flow-root;
              font-size: 15px;
              font-weight: 500;
              color: #000000;
              padding-left: 10px;
              border-left: 5px solid #409eff;
              margin: 30px 0 5px 0;
              display: flex;
              align-items: center;
            "
          >
            {{ $t("machineConfig.sbmoshi") }}
          </div>
          <el-row v-hasPerm="['usermahcine:hide:model']" :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('editUserMachine.userDeviceMode')" prop="type">
                <el-select
                  v-model="config.model.type"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pDeviceMode')"
                >
                  <el-option
                    v-for="item in deviceMode"
                    :key="item.value"
                    :label="item.label"
                    :value="+item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <block v-if="config.model.type == 1">
              <el-col :span="24" style="width: 98%; margin: 20px 0 0 0px">
                <div style="margin-bottom: 10px; font-weight: bold">{{ $t("user.ConfigUserMachine.891013-0") }}</div>
                <CustomDayTimePicker v-model="config.model.time" />
                <div style="margin-top: 6px; color: red">
                  {{ $t("machine.tishi") }}
                </div>
              </el-col>
            </block>
            <block v-if="config.model.type == 2">
              <el-col :span="6">
                <el-form-item :label="$t('editUserMachine.tipTitle')" prop="title">
                  <el-input
                    v-model="config.model.title"
                    :placeholder="$t('editUserMachine.pTipTitle')"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('editUserMachine.tipMessage')" prop="message">
                  <el-input
                    v-model="config.model.message"
                    :placeholder="$t('editUserMachine.pTipMessage')"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
            </block>
            <!-- 新增 -->
            <block v-if="config.model.type == 3">
              <el-col :span="18">
                <el-form-item :label="$t('bigScreen.lCustomSp')" prop="tipPassword" style="max-width: 66%">
                  <el-select
                    v-model="config.model.lockPage"
                    filterable
                    clearable
                    :no-data-text="$t('common.noData')"
                    :no-match-text="$t('common.noData')"
                    :placeholder="$t('bigScreen.pChooseCustomSp')"
                  >
                    <el-option :key="1" :label="$t('bigScreen.adHome')" :value="1"></el-option>
                    <el-option :key="2" :label="$t('bigScreen.productHome')" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('editUserMachine.tipPassword')" prop="passWord">
                  <el-input
                    v-model="config.model.passWord"
                    :placeholder="$t('editUserMachine.pTipPassword')"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('editUserMachine.tipMessage')" prop="message">
                  <el-input
                    v-model="config.model.message"
                    :placeholder="$t('editUserMachine.pTipMessage')"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 时间段选择 -->
              <el-col :span="24" style="width: 98%; margin: 20px 0 0 0px">
                <div style="margin-bottom: 10px; font-weight: bold">
                  {{ $t("bigScreen.passwordSpTime") }}
                </div>
                <CustomDayTimePicker v-model="config.model.time" />
                <div style="margin-top: 6px; color: red">
                  {{ $t("machine.tishi") }}
                </div>
              </el-col>
            </block>
          </el-row>
          <el-row v-hasPerm="['usermahcine:hide:model']" v-if="config.model.type == 2" :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('editUserMachine.isTip')" prop="isPrompt">
                <el-select
                  v-model="config.model.isPrompt"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item :label="$t('editUserMachine.userTipConfirm')" prop="confirm">
                <el-input
                  v-model="config.model.confirm"
                  :placeholder="$t('editUserMachine.puserTipConfirm')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item :label="$t('editUserMachine.userTipCancel')" prop="cancel">
                <el-input
                  v-model="config.model.cancel"
                  :placeholder="$t('editUserMachine.puserTipCancel')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 线上支付 -->
          <!-- <div
            v-hasPerm="['usermahcine:hide:xspay']"
            style="
              height: 24px;
              line-height: 24px;
              display: flow-root;
              font-size: 15px;
              font-weight: 500;
              color: #000000;
              padding-left: 10px;
              border-left: 5px solid #409eff;
              margin: 30px 0 5px 0;
              display: flex;
              align-items: center;
            "
          >
            {{ $t("machineConfig.xspay") }}
          </div>
          <el-row :gutter="20" v-hasPerm="['usermahcine:hide:xspay']">
            <el-col :span="12">
              <el-form-item :label="$t('editUserMachine.isSms')" prop="isSms">
                <el-select
                  v-model="config.info.isSms"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- 设备税率 -->
          <div
            v-hasPerm="['user:machine:taexrat']"
            style="
              height: 24px;
              line-height: 24px;
              display: flow-root;
              font-size: 15px;
              font-weight: 500;
              color: #000000;
              padding-left: 10px;
              border-left: 5px solid #409eff;
              margin: 30px 0 5px 0;
              display: flex;
              align-items: center;
            "
          >
            {{ $t("editUserMachine.vatRate") }}
          </div>
          <el-row :gutter="20" v-hasPerm="['user:machine:taexrat']">
            <el-col :span="12">
              <el-form-item :label="$t('editUserMachine.vatRateLock')" prop="config.vatRate.isOpen">
                <el-select
                  v-model="config.vatRate.isOpen"
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$t('user.ConfigUserMachine.578548-0')"
                prop="config.vatRate.isOpen"
                v-show="config.vatRate.isOpen == '1'"
              >
                <el-select
                  v-model="config.vatRate.isCalculating"
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option
                    v-for="item in vatRateIsHaveArr"
                    :key="item.value"
                    :label="item.label"
                    :value="+item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-show="config.vatRate.isOpen == '1'" v-hasPerm="['user:machine:taexrat']">
            <el-col :span="12">
              <el-form-item :label="$t('editUserMachine.vatRateSet')">
                <el-select
                  v-model="config.vatRate.type"
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option
                    v-for="item in vatRateSetArr"
                    :key="item.value"
                    :label="item.label"
                    :value="+item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="config.vatRate.type == 1">
              <el-form-item :label="$t('editUserMachine.taxTyRateBfbSet')">
                <el-input :min="0" :max="100" type="number" v-model="config.vatRate.proportion">
                  <template #suffix> % </template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-else style="color: red; margin-top: 40px">
              {{ $t("editUserMachine.vatRateTips") }}
            </el-col>
          </el-row>

          <!-- 购物提示 -->
          <div
            style="
              height: 24px;
              line-height: 24px;
              display: flow-root;
              font-size: 15px;
              font-weight: 500;
              color: #000000;
              padding-left: 10px;
              border-left: 5px solid #409eff;
              margin: 30px 0 5px 0;
              display: flex;
              align-items: center;
            "
          >
            {{ $t("machineConfig.gouwutishi") }}
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('editUserMachine.isShoppingTip')" prop="isTip">
                <el-select
                  v-model="config.shopping.isTip"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="config.shopping.isTip == 1" :gutter="20">
            <el-col :span="8">
              <el-form-item :label="$t('editUserMachine.shoppingTipTitle')" prop="tipTitle">
                <el-input
                  v-model="config.shopping.tipTitle"
                  :placeholder="$t('editUserMachine.pShoppingTipTitle')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('editUserMachine.shoppingTipMessage')" prop="tipMessage">
                <el-input
                  v-model="config.shopping.tipMessage"
                  :placeholder="$t('editUserMachine.pShoppingTipMessage')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$t('editUserMachine.shoppingTipConfirm')" prop="tipConfirm">
                <el-input
                  v-model="config.shopping.tipConfirm"
                  :placeholder="$t('editUserMachine.pShoppingTipConfirm')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$t('editUserMachine.shoppingTipCancel')" prop="tipCancel">
                <el-input
                  v-model="config.shopping.tipCancel"
                  :placeholder="$t('editUserMachine.pShoppingTipCancel')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 购物车 -->
          <div
            v-hasPerm="['usermahcine:hide:cart']"
            style="
              height: 24px;
              line-height: 24px;
              display: flow-root;
              font-size: 15px;
              font-weight: 500;
              color: #000000;
              padding-left: 10px;
              border-left: 5px solid #409eff;
              margin: 30px 0 5px 0;
              display: flex;
              align-items: center;
            "
          >
            {{ $t("machineConfig.gouwuche") }}
          </div>
          <el-row :gutter="20" v-hasPerm="['usermahcine:hide:cart']">
            <el-col :span="12">
              <el-form-item :label="$t('editUserMachine.cartNum')" prop="cartNum">
                <el-input
                  v-model="config.shopping.cartNum"
                  :placeholder="$t('editUserMachine.pCartNum')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('editUserMachine.isCart')" prop="isCart">
                <el-select
                  v-model="config.shopping.isCart"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 遥控器 -->
          <!-- <div
						style="height: 24px; line-height: 24px; display: flow-root; font-size: 15px; font-weight: 500; color: #000000; padding-left: 10px; border-left: 5px solid #409EFF; margin: 30px 0 5px 0; display: flex; align-items: center;"
					>
						{{ $t("machineConfig.yaokongqi") }}
					</div>
					<el-row :gutter="20">
						<el-col :span="6">
							<el-form-item
								:label="$t('editUserMachine.isRemoteControl')"
								prop="isBlue"
							>
								<el-select
									v-model="config.remote.isBlue"
									filterable
									clearable
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									:placeholder="$t('editUserMachine.pIsEnable')"
								>
									<el-option
										v-for="item in yesNo"
										:key="item.id"
										:label="item.label"
										:value="+item.value"
									></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12" v-if="config.remote.isBlue > 0">
							<el-form-item
								:label="$t('editUserMachine.remoteLock')"
								prop="blueType"
							>
								<el-select
									v-model="config.remote.blueType"
									filterable
									clearable
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									:placeholder="$t('editUserMachine.pIsEnable')"
								>
									<el-option
										v-for="item in feelLock"
										:key="item.id"
										:label="item.label"
										:value="+item.value"
									></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="6">
							<el-form-item
								:label="$t('editUserMachine.isFeelControl')"
								prop="isHaptic"
							>
								<el-select
									v-model="config.remote.isHaptic"
									filterable
									clearable
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									:placeholder="$t('editUserMachine.pIsEnable')"
								>
									<el-option
										v-for="item in yesNo"
										:key="item.id"
										:label="item.label"
										:value="+item.value"
									></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12" v-if="config.remote.isHaptic > 0">
							<el-form-item
								:label="$t('editUserMachine.feelLock')"
								prop="hapticType"
							>
								<el-select
									v-model="config.remote.hapticType"
									filterable
									clearable
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									:placeholder="$t('editUserMachine.pIsEnable')"
								>
									<el-option
										v-for="item in feelLock"
										:key="item.id"
										:label="item.label"
										:value="+item.value"
									></el-option>
								</el-select>
							</el-form-item>
						</el-col> -->

          <!-- 年龄识别开始-->
          <div
            style="
              height: 24px;
              line-height: 24px;
              display: flow-root;
              font-size: 15px;
              font-weight: 500;
              color: #000000;
              padding-left: 10px;
              border-left: 5px solid #409eff;
              margin: 30px 0 5px 0;
              display: flex;
              align-items: center;
            "
          >
            {{ $t("machineConfig.nlsb") }}
          </div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('machineConfig.nlsbkg')" prop="isAge">
                <el-select
                  v-model="config.age.isAge"
                  @change="config.age.ageDevice = ''"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="config.age.isAge == 1">
            <!-- 年龄识别选择范围 -->
            <el-col :span="6">
              <el-form-item :label="$t('user.ConfigUserMachine.331464-0')" prop="ageRange">
                <el-select
                  v-model="config.age.ageRange"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option
                    v-for="item in ageRangeArr"
                    :key="item.value"
                    :label="item.label"
                    :value="+item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="config.age.ageRange != 1">
              <el-form-item :label="$t('user.ConfigUserMachine.051200-0')" prop="ageNum">
                <el-input
                  v-model.number="config.age.ageNum"
                  :placeholder="$t('user.ConfigUserMachine.051200-1')"
                  autocomplete="off"
                  type="number"
                  min="0"
                  oninput="if(value < 0) value = 0"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('user.ConfigUserMachine.716321-0')" prop="ageCountdown">
                <el-input
                  v-model.number="config.age.ageCountdown"
                  :placeholder="$t('user.ConfigUserMachine.716321-1')"
                  autocomplete="off"
                  type="number"
                  min="0"
                  oninput="if(value < 0) value = 0"
                >
                  <template #append>s</template>
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 年龄识别设备选择 -->
            <el-col v-if="config.age.isAge == 1" :span="6">
              <el-form-item :label="$t('machineConfig.nlsbsbxz')" prop="ageDevice">
                <el-select
                  v-model="config.age.ageDevice"
                  @change="handlerChangeIsAge"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('machineConfig.nlsbsbxz')"
                >
                  <el-option
                    v-for="item in ageDevice"
                    :key="item.id"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <div style="color: red" v-show="config.age.ageDevice == '1.4.1'">
                  {{ $t("machineConfig.yzjiage") }}0.23{{ $t("machineConfig.yzjiagec") }}
                </div>
                <div style="color: red" v-show="config.age.ageDevice == '1.4.12'">
                  {{ $t("machineConfig.yzjiage") }}0.8{{ $t("machineConfig.yzjiagec") }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="config.age.isAge == 1" :gutter="20" style="width: 98%; margin: 20px 0 0 0px">
            <div style="margin-bottom: 10px; font-weight: bold">
              {{ $t("machineConfig.aratps") }}
            </div>
            <CustomDayTimePicker v-model="config.age.time" />
            <div style="margin-top: 6px; color: red">
              {{ $t("machine.tishi") }}
            </div>
          </el-row>
          <!-- 电子锁 -->
          <div
            v-hasPerm="['usermahcine:hide:electroniclock']"
            style="
              height: 24px;
              line-height: 24px;
              display: flow-root;
              font-size: 15px;
              font-weight: 500;
              color: #000000;
              padding-left: 10px;
              border-left: 5px solid #409eff;
              margin: 30px 0 5px 0;
              display: flex;
              align-items: center;
            "
          >
            {{ $t("machineConfig.electricLock") }}
          </div>
          <el-row v-hasPerm="['usermahcine:hide:electroniclock']" :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('machineConfig.isElectricLock')">
                <el-button v-if="!config.elock.isOpen" @click="handlerOpenElock" type="warning" size="small">
                  {{ $t("user.ConfigUserMachine.660097-0") }}
                </el-button>
                <el-button v-else @click="config.elock.isOpen = 0" type="danger" size="small">
                  {{ $t("user.ConfigUserMachine.660097-1") }}
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 光眼开光 -->
          <div
            v-hasPerm="['usermahcine:hide:lighteye']"
            style="
              height: 24px;
              line-height: 24px;
              display: flow-root;
              font-size: 15px;
              font-weight: 500;
              color: #000000;
              padding-left: 10px;
              border-left: 5px solid #409eff;
              margin: 30px 0 5px 0;
              display: flex;
              align-items: center;
            "
          >
            {{ $t("machineConfig.isEyes") }}
          </div>
          <el-row :gutter="20" v-hasPerm="['usermahcine:hide:lighteye']">
            <el-col :span="6">
              <el-form-item :label="$t('machineConfig.isEye')">
                <el-select
                  v-model="config.info.isEye"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="18" style="padding-top: 50px">
              <sqpan style="color: red">{{ $t("machineConfig.closeEye") }}</sqpan>
            </el-col>
          </el-row>
          <!-- 反馈设置模块 -->
          <template>
            <div
              style="
                height: 24px;
                line-height: 24px;
                display: flow-root;
                font-size: 15px;
                font-weight: 500;
                color: #000000;
                padding-left: 10px;
                border-left: 5px solid #409eff;
                margin: 30px 0 5px 0;
                display: flex;
                align-items: center;
              "
            >
              {{ $t("user.ConfigUserMachine.475723-0") }}
            </div>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('user.ConfigUserMachine.475723-1')" prop="feedback.isOpen">
                  <el-select
                    v-model="config.feedback.isOpen"
                    :no-data-text="$t('common.noData')"
                    :no-match-text="$t('common.noData')"
                  >
                    <el-option
                      v-for="item in yesNo"
                      :key="item.id"
                      :label="item.label"
                      :value="+item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="config.feedback.isOpen == 1">
                <el-form-item :label="$t('user.ConfigUserMachine.798430-0')" prop="feedback.type">
                  <el-select
                    v-model="config.feedback.type"
                    :no-data-text="$t('common.noData')"
                    :no-match-text="$t('common.noData')"
                    :placeholder="$t('user.ConfigUserMachine.798430-1')"
                  >
                    <el-option :label="$t('user.ConfigUserMachine.798430-2')" :value="1"></el-option>
                    <el-option :label="$t('user.ConfigUserMachine.798430-3')" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="config.feedback.isOpen == 1">
              <el-col :span="24">
                <!-- 标题多语言设置 -->
                <el-form-item :label="$t('user.ConfigUserMachine.475723-4')" prop="feedback.titleLang">
                  <div>
                    <el-row v-if="config.feedback.titleLang" style="margin-bottom: 10px">
                      <el-col :span="24">
                        <el-collapse>
                          <el-collapse-item>
                            <template slot="title">
                              <div style="color: #409eff">{{ $t("user.ConfigUserMachine.475723-4") }}： { ... }</div>
                            </template>
                            <div
                              v-for="(lang, langCode) in config.feedback.titleLang"
                              :key="langCode"
                              style="margin-bottom: 10px"
                            >
                              <el-row :gutter="10">
                                <el-col :span="6">
                                  <strong>{{ getLangLabel(langCode) }}:</strong>
                                </el-col>
                                <el-col :span="18">
                                  <el-input
                                    v-model="config.feedback.titleLang[langCode]"
                                    :placeholder="$t('user.ConfigUserMachine.475723-5')"
                                  ></el-input>
                                </el-col>
                              </el-row>
                            </div>
                          </el-collapse-item>
                        </el-collapse>
                      </el-col>
                    </el-row>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20" v-if="config.feedback.isOpen == 1">
              <el-col :span="24">
                <!-- 内容多语言设置 -->
                <el-form-item :label="$t('user.ConfigUserMachine.475723-2')" prop="feedback.introduceLang">
                  <div>
                    <el-row v-if="config.feedback.introduceLang" style="margin-bottom: 10px">
                      <el-col :span="24">
                        <el-collapse>
                          <el-collapse-item>
                            <template slot="title">
                              <div style="color: #409eff">{{ $t("user.ConfigUserMachine.475723-2") }}： { ... }</div>
                            </template>
                            <div
                              v-for="(lang, langCode) in config.feedback.introduceLang"
                              :key="langCode"
                              style="margin-bottom: 10px"
                            >
                              <el-row :gutter="10">
                                <el-col :span="6">
                                  <strong>{{ getLangLabel(langCode) }}:</strong>
                                </el-col>
                                <el-col :span="18">
                                  <el-input
                                    type="textarea"
                                    :autosize="{ minRows: 2, maxRows: 4 }"
                                    v-model="config.feedback.introduceLang[langCode]"
                                    :placeholder="$t('user.ConfigUserMachine.475723-3')"
                                  ></el-input>
                                </el-col>
                              </el-row>
                            </div>
                          </el-collapse-item>
                        </el-collapse>
                      </el-col>
                    </el-row>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20" v-if="config.feedback.isOpen == 1">
              <el-col :span="6">
                <el-form-item :label="$t('user.ConfigUserMachine.475723-6')" prop="feedback.phone">
                  <el-input :placeholder="$t('user.ConfigUserMachine.475723-5')" v-model="config.feedback.phone">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20" v-if="config.feedback.isOpen == 1 && config.feedback.type == 1">
              <el-col :span="6">
                <el-form-item :label="$t('user.ConfigUserMachine.475723-7')" prop="feedback.qrCode">
                  <CustomUploadImg
                    :url.sync="config.feedback.qrCode"
                    :action="uploadFeedbackUrl"
                    :headers="headers"
                    :accept="'.jpg,.png'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </template>
          <!-- 推荐商品文案设置 -->
          <template>
            <div
              style="
                height: 24px;
                line-height: 24px;
                display: flow-root;
                font-size: 15px;
                font-weight: 500;
                color: #000000;
                padding-left: 10px;
                border-left: 5px solid #409eff;
                margin: 30px 0 5px 0;
                display: flex;
                align-items: center;
              "
            >
              {{ $t("user.ConfigUserMachine.784649-0") }}
            </div>
            <el-row :gutter="20">
              <el-col :span="24">
                <!-- 标题多语言设置 -->
                <el-form-item :label="''" prop="shopping.recommendTextLang">
                  <div>
                    <el-row v-if="config.shopping.recommendTextLang" style="margin-bottom: 10px">
                      <el-col :span="24">
                        <el-collapse>
                          <el-collapse-item>
                            <template slot="title">
                              <div style="color: #409eff">{{ $t("user.ConfigUserMachine.784649-1") }} { ... }</div>
                            </template>
                            <el-row :gutter="20">
                              <el-col :span="20">
                                <div
                                  v-for="(lang, langCode) in config.shopping.recommendTextLang"
                                  :key="langCode"
                                  style="margin-bottom: 10px"
                                >
                                  <el-row :gutter="10">
                                    <el-col :span="6">
                                      <strong>{{ getLangLabel(langCode) }}:</strong>
                                    </el-col>
                                    <el-col :span="18">
                                      <el-input
                                        :ref="`recommendTextArea_${langCode}`"
                                        type="textarea"
                                        :autosize="{ minRows: 2, maxRows: 6 }"
                                        :maxlength="100"
                                        :show-word-limit="true"
                                        v-model="config.shopping.recommendTextLang[langCode]"
                                        :placeholder="$t('user.ConfigUserMachine.475723-5')"
                                        @focus="handleRecommendTextFocus($event, langCode)"
                                      ></el-input>
                                    </el-col>
                                  </el-row>
                                </div>
                              </el-col>
                              <el-col :span="4">
                                <!-- 变量列表 -->
                                <div class="variable-panel">
                                  <div class="variable-panel-title">{{ $t("user.ConfigUserMachine.557927-0") }}</div>
                                  <div>
                                    <el-button
                                      size="mini"
                                      type="text"
                                      class="variable-button"
                                      @click="insertRecommendVariable('{productName}')"
                                      :disabled="!currentRecommendTextInput"
                                    >
                                      {{ $t("user.ConfigUserMachine.557927-1") }}
                                    </el-button>
                                  </div>
                                  <div class="variable-panel-tip">
                                    {{
                                      currentRecommendTextInput
                                        ? $t("user.ConfigUserMachine.557927-2")
                                        : $t("user.ConfigUserMachine.557927-3")
                                    }}
                                  </div>
                                </div>
                              </el-col>
                            </el-row>
                          </el-collapse-item>
                        </el-collapse>
                      </el-col>
                    </el-row>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </template>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('')" size="small">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" size="small" :disabled="loadingForm" @click="submitForm('userEquipment')">{{
          $t("common.definite")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 用户验证 -->
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('machineConfig.yhyanz')"
      :visible.sync="dialogSmsVisible"
      width="305px"
      custom-class="SmsVerify"
      :before-close="handleVerifySmsClose"
      :close-on-click-modal="false"
    >
      <div>
        <p>{{ $t("machineConfig.yanztips") }}</p>
        <el-select v-model="verifyvalue" style="margin: 10px 0" size="small">
          <el-option
            v-for="(vers, index) in verifyset"
            :key="index"
            :label="vers['name']"
            :value="vers['value']"
          ></el-option>
        </el-select>
        <template v-if="issend">
          <p style="margin-top: 5px; color: #67c23a">
            {{ $t("machineConfig.tips2") }}
          </p>
        </template>
        <div style="display: flex; align-items: center; margin-top: 5px">
          <el-input
            v-model="smscode"
            maxlength="6"
            :placeholder="$t('user.MachineMaps.171147-0')"
            style="margin-right: 15px"
            size="small"
          ></el-input>
          <el-button
            v-if="smscode && issend"
            type="primary"
            size="small"
            @click="handlerVerifySms"
            :loading="smsloading"
            >{{ $t("machineConfig.yanzhen") }}</el-button
          >
          <template v-else>
            <el-button v-if="!issend" type="primary" size="small" @click="handlerSendSms" :loading="smsloading">{{
              $t("machineConfig.sendbtn")
            }}</el-button>
            <el-button v-else type="primary" size="small" disabled
              >{{ $t("machineConfig.sendbtn") }}({{ miao }}s)</el-button
            >
          </template>
        </div>
      </div>
    </el-dialog>
    <!-- 弹窗提示年龄识别扣费 -->
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('user.ConfigUserMachine.879870-0')"
      :visible.sync="openIsAgeDialog"
      width="300px"
      :close-on-click-modal="false"
      center
    >
      <span>{{ $t("user.ConfigUserMachine.879870-1") }}</span>
      <span style="color: red">${{ walletPrice }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handlerToRecharge">{{ $t("user.ConfigUserMachine.879870-2") }}</el-button>
        <el-button size="small" v-if="walletPrice >= 1" type="primary" @click="handlerContinueOpen">{{
          $t("user.ConfigUserMachine.879870-3")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import CustomDayTimePicker from "@/components/CustomDayTimePicker.vue";
  import CustomUploadImg from "@/components/CustomUploadImg.vue";
  import config from "@/http/config";
  export default {
    name: "ConfigUserMachine",
    components: { CustomDayTimePicker, CustomUploadImg },
    props: {
      dialogConfigMachine: Boolean,
      userEquipment: Object,
      yesNo: Array,
      ageDevice: Array,
      feelLock: Array,
      ageType: Array,
      priorityMode: Array,
      deviceMode: Array,
      biaoshi: Boolean,
      IdcardCountry: Array,
      advertPlayMode: Array
    },
    data() {
      return {
        // 所有配置
        config: {
          age: {
            time: []
          },
          advert: {},
          elock: {},
          info: {},
          manager: {},
          model: {
            time: []
          },
          remote: {},
          shopping: {},
          vatRate: {},
          feedback: {
            titleLang: {},
            introduceLang: {}
          }
        },
        // 活动语言标签
        activeFeedbackLanguage: this.$i18n.locale || "zh_CN",
        // 存储多语言数据
        feedbackLanguages: [],
        verify: [],
        labelPosition: "top",
        loadingForm: false,
        props: {
          label: "name",
          children: "zones"
        },

        count: 1,
        limit: 1,
        defaultCheckedKeys: [],
        uploadUrl: config.baseUrl + this.$url.IDard.cert,
        uploadFeedbackUrl: config.baseUrl + this.$url.Upload.feedback,
        headers: {
          token: this.$cookies.get("token")
        },
        certImgList: [],
        //  开锁验证
        dialogSmsVisible: false,
        issend: false,
        smscode: "",
        smsloading: false,
        miao: 180,
        localIsElectricLock: "",
        verifyvalue: "",
        verifyset: [],
        shibiePrice: 0,
        vatRateSetArr: [
          {
            label: this.$t("editUserMachine.taxTyRateSet"),
            value: "1"
          },
          {
            label: this.$t("editUserMachine.taxDdRateSet"),
            value: "2"
          }
        ],
        vatRateIsHaveArr: [
          {
            label: this.$t("editUserMachine.taxInclude"),
            value: "0"
          },
          {
            label: this.$t("editUserMachine.taxunInclude"),
            value: "1"
          }
        ],
        userName: "",
        // 年龄识别应用范围
        ageRangeArr: [
          {
            value: "1",
            label: this.$t("user.ConfigUserMachine.331464-1")
          },
          {
            value: "2",
            label: this.$t("user.ConfigUserMachine.331464-2")
          },
          {
            value: "3",
            label: this.$t("user.ConfigUserMachine.716321-2")
          },
          {
            value: "4",
            label: this.$t("user.ConfigUserMachine.716321-3")
          }
        ],
        //钱包余额
        walletPrice: 0,
        openIsAgeDialog: false,
        // 当前聚焦的推荐文案输入框
        currentRecommendTextInput: null,
        currentRecommendTextLangCode: null
      };
    },
    mounted() {
      this.handlerGetShibiePrice();
      this.userName = localStorage.getItem("userName");
    },
    methods: {
      handlerToRecharge() {
        this.$router.push("/mywallet/topup");
      },
      handlerContinueOpen() {
        this.config.age.isAge = 1;
        this.openIsAgeDialog = false;
      },
      handlerChangeIsAge(e) {
        console.log(e, "e");
        // //AgeRecognitionScanner 年龄识别扫描器
        // if (e != "AgeRecognitionScanner" && this.walletPrice < 10) {
        //   this.config.age.ageDevice = "";
        //   this.openIsAgeDialog = true;
        // }
      },
      handlerGetShibiePrice() {
        this.$api.dict("face_accuracy").then(res => {
          if (res.data.length > 0) {
            this.shibiePrice = res.data[0].label;
          }
        });
      },
      isAdmin() {
        if (this.userName == "admin1") return true;
        return false;
      },
      handlerOpenElock() {
        const _self = this; // 保存当前上下文的引用
        _self.dialogSmsVisible = true; // 显示短信验证对话框
        const verify = _self.verify;
        // 如果存在验证信息，则进行处理
        if (verify && verify.length > 0) {
          verify.forEach(item => {
            if (item["type"] === "1") {
              // 邮件验证
              const email = item["value"];
              if (email.indexOf("@") === -1) {
                item["name"] = `${email} (${_self.$t("machineConfig.email")})`;
              } else {
                const [email1, email2] = email.split("@");
                const avg = Math.floor(email1.length / 2);
                const maskedEmail = `${email1.substring(0, email1.length - avg)}***@${email2}`;
                item["name"] = `${maskedEmail} (${_self.$t("machineConfig.email")})`;
              }
            } else if (item["type"] === "2") {
              // 手机验证
              const userPhone = item["value"].replace(/(\d{3})\d*(\d{4})/, "$1****$2");
              item["name"] = `${userPhone} (${_self.$t("machineConfig.phone")})`;
            }
          });

          _self.verifyset = verify; // 更新验证集合
          _self.verifyvalue = verify[0]["value"]; // 设置默认验证值
        }
      },
      handlerSendSms() {
        let _self = this;
        let verifyset = _self.verifyset;
        let verifytype = "";
        for (let i = 0; i < verifyset.length; i++) {
          if (_self.verifyvalue == verifyset[i]["value"]) {
            verifytype = verifyset[i]["type"];
          }
        }
        _self.smsloading = true;
        let rData = {
          equipmentNo: _self.userEquipment.equipmentNo,
          type: verifytype,
          verify: _self.verifyvalue
        };
        // 设备分组批量改
        if (rData.equipmentNo == "") {
          rData.teamId = _self.userEquipment.id;
          delete rData.equipmentNo;
        }
        _self.$api
          .request(_self.$url.UserMachine.getCode, _self.$method.post, rData)
          .then(res => {
            _self.smsloading = false;
            if (parseInt(res.code) == 0) {
              _self.issend = true;
              let dsq = window.setInterval(function () {
                if (_self.miao <= 1) {
                  window.clearInterval(dsq);
                  _self.issend = false;
                  _self.miao = 180;
                  return false;
                }
                _self.miao = parseInt(_self.miao) - 1;
                if (_self.miao < 10) {
                  _self.miao = "0" + _self.miao;
                }
              }, 1000);
            } else {
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(res => {
            _self.smsloading = false;
            _self.$notify({
              title: _self.$t("common.tip"),
              message: res.msg,
              type: "warning"
            });
          });
      },
      handlerVerifySms() {
        let _self = this;
        if (!_self.smscode) {
          _self.$message({
            message: _self.$t("machineConfig.ppsmsemail"),
            type: "warning"
          });
          return false;
        }
        _self.smsloading = true;
        let rData = {
          equipmentNo: _self.userEquipment.equipmentNo,
          verify: _self.verifyvalue,
          code: _self.smscode,
          unLock: 1
        };
        // 设备分组批量改
        if (rData.equipmentNo == "") {
          rData.teamId = _self.userEquipment.id;
          delete rData.equipmentNo;
        }
        _self.$api
          .request(_self.$url.UserMachine.validCode, _self.$method.post, rData)
          .then(res => {
            _self.smsloading = false;
            if (parseInt(res.code) == 0) {
              _self.config.elock.isOpen = 1;
              _self.dialogSmsVisible = false;
              return false;
            } else {
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(res => {
            _self.smsloading = false;
            _self.$notify({
              title: _self.$t("common.tip"),
              message: res.msg,
              type: "warning"
            });
          });
      },
      handleVerifySmsClose() {
        let _self = this;
        _self.issend = false;
        _self.smscode = "";
        _self.smsloading = false;
        _self.miao = 180;
        _self.localIsElectricLock = "";
        _self.verifyvalue = "";
        _self.dialogSmsVisible = false;
      },
      openDialog() {
        // 设置配置
        this.config = JSON.parse(JSON.stringify(this.userEquipment.config));
        console.log(this.userEquipment.walletPrice, this.$t("user.ConfigUserMachine.879870-4"));
        //钱包余额赋值
        if (this.userEquipment.walletPrice) {
          this.walletPrice = this.userEquipment.walletPrice;
        } else {
          this.walletPrice = 0;
        }
        // 确保feedback属性存在
        if (!this.config.feedback) {
          this.config.feedback = {};
        }

        // 初始化多语言数据
        this.initFeedbackLanguageData();

        // 初始化推荐商品文案多语言数据
        this.initRecommendTextLanguageData();

        // 填充时间
        if (this.config.age.time.length <= 0) {
          this.config.age.time = this.handlerFillTime();
        }
        if (this.config.model.time.length <= 0) {
          this.config.model.time = this.handlerFillTime();
        }
        this.verify = JSON.parse(JSON.stringify(this.userEquipment.verify));
      },

      // 初始化反馈多语言数据
      initFeedbackLanguageData() {
        // 获取系统支持的语言列表
        const langList = this.$store.state.langList || [];

        // 如果没有feedback属性，创建一个
        if (!this.config.feedback) {
          this.config.feedback = {};
        }

        // 如果没有titleLang和introduceLang属性，创建一个
        if (!this.config.feedback.titleLang) {
          this.$set(this.config.feedback, "titleLang", {});
        }
        if (!this.config.feedback.introduceLang) {
          this.$set(this.config.feedback, "introduceLang", {});
        }

        // 保存原始数据用于迁移
        const originalIntroduce = this.config.feedback.introduce;
        const originalTitle = this.config.feedback.title;

        // 为每种语言创建数据
        langList.forEach(lang => {
          // 如果该语言标题还未设置，赋予默认值
          if (!this.config.feedback.titleLang[lang.value]) {
            this.$set(this.config.feedback.titleLang, lang.value, originalTitle || "");
          }

          // 如果该语言介绍还未设置，赋予默认值
          if (!this.config.feedback.introduceLang[lang.value]) {
            this.$set(this.config.feedback.introduceLang, lang.value, originalIntroduce || "");
          }
        });
      },

      // 初始化推荐商品文案多语言数据
      initRecommendTextLanguageData() {
        // 获取系统支持的语言列表
        const langList = this.$store.state.langList || [];

        // 如果没有shopping属性，创建一个
        if (!this.config.shopping) {
          this.config.shopping = {};
        }

        // 如果没有recommendTextLang属性，创建一个
        if (!this.config.shopping.recommendTextLang) {
          this.$set(this.config.shopping, "recommendTextLang", {});
        }

        // 保存原始数据用于迁移
        const originalRecommendText = this.config.shopping.recommendText;

        // 为每种语言创建数据
        langList.forEach(lang => {
          // 如果该语言推荐文案还未设置，赋予默认值
          if (!this.config.shopping.recommendTextLang[lang.value]) {
            this.$set(this.config.shopping.recommendTextLang, lang.value, originalRecommendText || "");
          }
        });
      },
      handlerFillTime() {
        let arr = [];
        for (let i = 0; i < 168; i++) {
          let week = Math.floor(i / 24) + 1; // 使用 Math.floor 确保 week 在 1 到 7 之间
          let hour = i % 24;
          let start = `${("0" + hour).slice(-2)}:00:00`;
          let end = `${("0" + hour).slice(-2)}:59:59`;
          arr.push({
            start: start,
            end: end,
            week: week
          });
        }
        return arr;
      },
      closeDialog() {
        this.clearValidate("userEquipment");
        // 重置推荐文案输入框状态
        this.currentRecommendTextInput = null;
        this.currentRecommendTextLangCode = null;
        this.cancel("");
      },
      cancel(state, code) {
        this.$emit("cancel", false, state, code);
      },
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          console.log(this.userEquipment);
          if (valid) {
            //  人脸识别精准度
            if ((this.config.age.faceSimilarity < 1 || this.config.age.faceSimilarity > 100) && this.biaoshi != 1) {
              this.$notify({
                title: this.$t("common.tip"),
                message: this.$t("machineConfig.jzczzs"),
                type: "warning"
              });
              return false;
            }

            let tjInfo = JSON.parse(JSON.stringify(this.userEquipment));
            tjInfo.config = JSON.parse(JSON.stringify(this.config));

            // 处理多语言数据，将对象格式转换为数组格式（如果后端需要）
            if (tjInfo.config.feedback) {
              // 保留原始的单语言字段用于兼容
              if (tjInfo.config.feedback.titleLang && Object.keys(tjInfo.config.feedback.titleLang).length > 0) {
                const firstLangKey = Object.keys(tjInfo.config.feedback.titleLang)[0];
                tjInfo.config.feedback.title = tjInfo.config.feedback.titleLang[firstLangKey] || "";
              }

              if (
                tjInfo.config.feedback.introduceLang &&
                Object.keys(tjInfo.config.feedback.introduceLang).length > 0
              ) {
                const firstLangKey = Object.keys(tjInfo.config.feedback.introduceLang)[0];
                tjInfo.config.feedback.introduce = tjInfo.config.feedback.introduceLang[firstLangKey] || "";
              }

              // 如果需要将对象格式转换为数组格式，可以在这里进行转换
              // 这部分代码取决于后端API的需求
            }

            // 如果全选传[]
            if (tjInfo.config.age.time?.length >= 168) {
              tjInfo.config.age.time = [];
            }
            if (tjInfo.config.model.time?.length >= 168) {
              tjInfo.config.model.time = [];
            }

            // 时间段判空
            if (!tjInfo.config.age.time) {
              tjInfo.config.age.time = [];
            }
            if (!tjInfo.config.model.time) {
              tjInfo.config.model.time = [];
            }

            // request
            let url = "";
            if (this.biaoshi == 1) {
              //  批量配置设备
              url = this.$url.UserMachine.gmodify;
            } else {
              //  单设备配置
              url = this.$url.UserMachine.modify;
            }
            this.loadingForm = true;
            this.$api
              .request(url, this.$method.put, tjInfo)
              .then(res => {
                if (res.code === 0) {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: this.$t("editUserMachine.up"),
                    type: "success"
                  });
                  this.cancel("update");
                }
                this.loadingForm = false;
              })
              .catch(() => {
                this.loadingForm = false;
              });
          }
        });
      },
      clearValidate(formName) {
        this.$refs[formName].clearValidate();
      },
      getLangLabel(langCode) {
        const langList = this.$store.state.langList || [];
        const lang = langList.find(item => item.value === langCode);
        return lang ? lang.label : langCode;
      },

      // 处理推荐文案输入框聚焦
      handleRecommendTextFocus(event, langCode) {
        this.currentRecommendTextInput = event.target;
        this.currentRecommendTextLangCode = langCode;
      },

      // 插入推荐文案变量
      insertRecommendVariable(variable) {
        if (!this.currentRecommendTextInput || !this.currentRecommendTextLangCode) {
          this.$message.warning(this.$t("user.ConfigUserMachine.557927-3"));
          return;
        }

        const input = this.currentRecommendTextInput;
        const cursorPosition = input.selectionStart;
        const textBefore = input.value.substring(0, cursorPosition);
        const textAfter = input.value.substring(cursorPosition);

        // 更新模型数据
        const newValue = textBefore + variable + textAfter;
        this.$set(this.config.shopping.recommendTextLang, this.currentRecommendTextLangCode, newValue);

        // 在下个事件循环中设置光标位置
        this.$nextTick(() => {
          const newCursorPosition = cursorPosition + variable.length;
          input.setSelectionRange(newCursorPosition, newCursorPosition);
          input.focus();
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  ::v-deep .mcVerify {
    border-radius: 6px;
    .el-dialog__header {
      padding: 15px 15px 15px 20px;
      background-color: #409eff;
      border-radius: 5px 5px 0 0;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: white;
    }
    .el-dialog__title {
      color: white;
    }
    .el-dialog__footer {
      padding: 20px;
    }
    .el-form--label-top .el-form-item__label {
      padding: 0;
    }
    .el-form-item {
      margin: 0;
    }
    .el-dialog__headerbtn {
      top: 20px;
      right: 15px;
    }
  }
  ::v-deep .SmsVerify {
    height: auto !important;
    .el-dialog__body {
      height: auto !important;
      padding: 20px;
    }
  }
  ::v-deep .mcVerify {
    height: 746px !important;
    .el-dialog__body {
      height: 600px !important;
      overflow-y: scroll;
      padding: 20px 10px 0 20px;
    }
  }

  // 变量面板样式
  .variable-panel {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 10px;
    background-color: #f5f7fa;

    .variable-panel-title {
      font-weight: bold;
      margin-bottom: 8px;
      color: #606266;
      font-size: 12px;
    }

    .variable-button {
      padding: 2px 5px !important;
      font-size: 12px !important;
      color: #409eff !important;
      text-decoration: underline;
      margin-bottom: 3px;
      display: block;

      &:hover {
        background-color: #ecf5ff;
      }

      &:disabled {
        color: #c0c4cc !important;
        text-decoration: none;
      }
    }

    .variable-panel-tip {
      font-size: 10px;
      color: #909399;
      margin-top: 5px;
    }
  }
</style>
